export const isContactAfterpaySupportFlow = (flow: string | undefined): boolean => flow === 'CONTACT_AFTERPAY_SUPPORT'
